/* eslint-disable no-unused-vars */

import { useLocation, useNavigate, useParams } from "react-router";
import {
  DocumentIcon,
  InvestigatorIcon,
} from "../../assets/common-svg/CommonSvg";
import CustomDetailComponent from "../../components/doctor-detail-component/DocotorDetail";
import { CustomWrapperCard } from "../../components/custom-product-cards/custom-wrapper-card/CustomWrapperCard";
import CustomTable from "../../components/custom-table/CustomTable";
import TrialInfoComponent from "../../components/trial-info-component/TrialInfoComponent";
import { Typography, useTheme, Chip } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import { phaseDetailsData } from "../../utils/tableData";
import PhaseApi from "../../services/phase";
import {
  setAssignedForm,
  setPhaseDetail,
} from "../../store/reducers/phase-reducer";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SubjectApi from "../../services/subjectService";
import { useDispatch, useSelector } from "react-redux";
import SubAdminApi from "../../services/subAdminService";
import {
  AddNewSubject,
  EditSubjectPhase,
} from "../../utils/formik/initialValues";
import {
  addNewSubjectValidationSchema,
  editSubjectPhaseValidationSchema,
  addNewSubjectPhaseValidationSchema,
  recordedDateSchema,
} from "../../utils/formik/validationSchema";
import CustomModel from "../../components/custom-model/CustomModel";
import DiseaseManagementApi from "../../services/diseaseService";
import { GenderList } from "../../utils/common";
import moment from "moment";
import SelectFormModel from "../../components/custom-model/SelectFormModel";
import NoDataCard from "../../components/no-data-card";
import ProductApi from "../../services/productService";
import ConfirmationModal from "../../components/modal-contents/ConfirmationModal";
import { notify } from "../../bmr/utils/methods/notification";
import { dateofBirthMoment } from "../../utils/utils";
import CustomAccordion from "../../components/custom-accordion/CustomAccordion";
import CustomDrawer from "../../components/custom-drawer/CustomDrawer.js";
import HeaderBackNav from "../../components/header-back-navigation/HeaderBackNav.js";
import CustomSearchbar from "../../components/custom-searchbar/CustomSearchbar.js";
import { PersonSvg } from "../../assets/common-svg/CommonSvg";
const convertSubjectData = (data, alignment, curr_page, page_details, order, isAddNewVisit, isAllApproved) => {
  return data?.map((sub, index) => {
    let SerialNo = order == 'asc' ? (page_details?.no_of_records - ((curr_page - 1) * 10)) - index : index + 1 + ((curr_page - 1) * 10);
    let transformId = sub?.id;
    let transformPatientId = sub?.patient_id || "--";
    let transformedSubjectInitial = sub?.first_name + " " + sub?.last_name || "";
     let transformedPatientStatus =
      sub?.life_status == "lost" ? (
        <div className="h-3 w-3 rounded-full bg-yellow-500"></div>
      ) : sub?.life_status == "alive" ? (
        <div className="h-3 w-3 rounded-full bg-green-500"></div>
      ) : (
        <div className="h-3 w-3 rounded-full bg-red-500"></div>
      );
 let transformedLastVisitType = sub?.last_visit_type || "--";
    let transformedGender = sub?.gender;
    let transformedInvestigator = sub?.investigatorDetails?.name || "N/A";
    let transformedHospitalName = sub?.hospitalDetails?.name || "--";
    let transformeappointmentCount = sub?.appointmentCount;
    let transformedCreatedBy = sub?.created_By?.name || "--";
    let roleName = sub?.created_By?.role_details?.title || "N/A";
    
    let editorData = [];
      if (sub?.userPi?.length) {
      editorData = sub.userPi.map(pi => ({
        id: pi.id,
        name: pi.name,
        role: pi.role_title,
      }));
    }
    
const transformedEditorCount = (editorData.length > 1) 
  ? editorData.length.toString() 
  : (editorData.length === 1) 
    ? editorData[0]?.name || "--" 
    : "--";
    let transformCycleCount = sub?.cycle;
    let transformedStatus =
      sub?.status_details?.status.charAt(0).toUpperCase() +
      sub?.status_details?.status.slice(1);
    let lastAppointmentDate = sub?.last_visit_type && sub?.last_appointment_date
      ? moment(sub?.last_appointment_date).format("DD/MM/YYYY")
      : sub?.last_visit_type && !sub?.last_appointment_date
      ? moment(sub?.created_at).format("DD/MM/YYYY")
      : "--";
    let phaseId = sub?.phase_id;
    let subjectId = sub?.id;
    let isActiveAppointment = isAddNewVisit ?? true;
    let allApproved = isAllApproved;
    let transformedPatientStatusText = 
      sub?.life_status == "lost" ? "Lost To Follow Up" : sub?.life_status;
    let qrCodeGenerationsID =
      sub?.feasibility_assessments?.qr_code_generations[0]?.id;   
    let apheresisDate =
      sub?.feasibility_assessments &&
      sub?.feasibility_assessments?.apheresis_date
        ? moment(sub?.feasibility_assessments?.apheresis_date).format(
            "DD/MM/YYYY"
          )
        : getStatusChip("No date assigned");
    let apheresisStatus =
      sub?.apheresis_status === "Requested" &&
      sub?.feasibility_assessments?.apheresis_date
        ? moment(sub?.feasibility_assessments?.apheresis_date).format(
            "DD/MM/YYYY"
          )
        : sub?.apheresis_status
        ? getStatusChip(sub?.apheresis_status)
        : getStatusChip("N/A");
    let prescreen_form = sub?.prescreen_form; //@info adding here status by replacing id due to id is generating even form is draft

    const displayData = alignment === "Subject"
      ? [
          transformPatientId,
          transformedSubjectInitial,
          transformedPatientStatus,
          transformedLastVisitType,
          transformeappointmentCount,
          transformedInvestigator,
          transformedHospitalName,
          transformedCreatedBy,
          roleName,
          transformedEditorCount,
          transformCycleCount,
          transformedGender,
          lastAppointmentDate,
          apheresisStatus,
          apheresisDate,
          transformId,
          phaseId,
          subjectId,
          isActiveAppointment,
          allApproved,
          transformedPatientStatusText,
          qrCodeGenerationsID,
          prescreen_form
        ]
      : [
          SerialNo,
          transformedSubjectInitial,
          transformeappointmentCount,
          transformedStatus,
          transformedLastVisitType,
          transformedGender,
          lastAppointmentDate,
          transformId,
        ];

    return {
      displayData,
      internalData: {
        editorData,
        rowId: transformId,
        originalData: sub
      }
    };
  });
};

const getStatusChip = (status) => {
  switch (status) {
    case "Pending":
      return <Chip label={status} color="error" />;
    case "Requested":
      return <Chip label={status} color="warning" />;
    case "Date Assigned":
      return <Chip label={status} color="success" />;
    default:
      return (
        <Chip
          label={status}
          sx={{
            backgroundColor: "#DDDDDD",
            color: "#828282",
          }}
        />
      );
  }
};

export const TrailsDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { loginId, role_id, role_slug } = useSelector((state) => state.loginData);
  const [phaseDetailLoading, setPhaseDetailLoading] = useState(false);
  const [isAddSubjectLoading, SetIsAddSubjectLoading] = useState(false);
  const [showAddSubjectButton, setShowAddSubjectButton] = useState(false);
  const [isFormLoading, SetIsFormLoading] = useState(false);
  const [isOpenFormModel, SetIsFormModel] = useState(false);
  const [recordedDate, setRecordedDate] = useState(null);
  const [recordedDateModel, setRecordedDateModel] = useState(false);
  const [recordedDateLoading, setRecordedDateLoading] = useState(null);
  const [isInvestigator] = useState(role_id === 2);
  const [isEditor] = useState(role_id === 5);
  const [isProjectManager] = useState(role_slug === "project-manager");
      const loginData = useSelector(state => state.loginData);
  
  const [phaseListDetails, setPhaseListDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [formTemplateList, setFormTemplateList] = useState([]);
  const [alignment, setAlignment] = useState("Subject");
  const [subjectData, setSubjectData] = useState(
    phaseDetailsData(alignment, role_id, role_slug)
  );
  const [status, setStatus] = useState([2]);
  const [tableFilters, setTablesFilters] = useState({ searchData: "" });
  const [currentPage, setCurrentpage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [openAddSubjectModal, setOpenAddSubjectModal] = useState(false);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [subAdminId, setSubAdminID] = useState(null);
  const [subAdminList, setsubAdminList] = useState([]);
  const [statusDropdownList, setStatusDropdownList] = useState([]);
  const [statusId, setStatusId] = useState([]);
  const [subjectId, setSubjectId] = useState("");
  const [patientCycleConfirm, setPatientCycleConfirm] = useState(false);
  const [patientCycleErrMess, setPatientCycleErrMess] = useState("");
  const [patientFormValues, setPatientFormValues] = useState({});
  const [patientCycleLoading, setPatientCycleLoading] = useState(false);
  const [allSubjectList, setAllSubjectList] = useState([]);
  const [openEditorDrawer, setOpenEditorDrawer] = useState(false);
const [editorDrawerData, setEditorDrawerData] = useState([]);
const [editorSearch, setEditorSearch] = useState("");
const [allSubjectListData, setAllSubjectListData] = useState([]);
  const [editSubjectPatient, setEditSubjectPatient] =
    useState(EditSubjectPhase);
  const [gender, setGender] = useState("");
  const [rowId, setRowId] = useState(null);
  const today = new Date();
const oneYearAgo = new Date(today);
oneYearAgo.setFullYear(today.getFullYear() - 1);

  const [disableDisease, setDisableDisease]=useState(false)
  const [expand, setExpanded] = useState(null);
  
  const handleExpand = (panelId) => {
    setExpanded(prev => (prev === panelId ? null : panelId));
  };
  
  const [modelData, setModelData] = useState({
    title: "Add New Patient",
    editTitle: "Edit Editor",
    children: isEditor 
      ? [
          {
            type: "input",
            name: "first_name",
            label: "First Name",
            placeholder: "Enter First Name",
            IsRequired: true,
          },
          {
            type: "input",
            name: "last_name",
            label: "Last Name",
            placeholder: "Enter Last Name",
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "gender",
            label: "Gender",
            placeholder: "Select gender",
            data: [],
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "disease_id",
            label: "Disease",
            placeholder: "Select disease",
            data: [],
            IsRequired: true,
            disabled: false,
          },
          {
            type: "date",
            name: "dob",
            label: "Date of Birth",
            placeholder: "Select Date",
            minDate: false,
            maxDate: oneYearAgo,
            IsRequired: true,
          },
        ]
      : [
          {
            type: "input",
            name: "first_name",
            label: "First Name",
            placeholder: "Enter First Name",
            IsRequired: true,
          },
          {
            type: "input",
            name: "last_name",
            label: "Last Name",
            placeholder: "Enter Last Name",
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "gender",
            label: "Gender",
            placeholder: "Select gender",
            data: [],
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "investigator_id",
            label: "Principal Investigator",
            placeholder: "Select principal investigator",
            data: [],
            IsRequired: true,
             onChange: (value) => {
            getEditorDropdown(value);
          }
          },
          {
            type: "dropdown",
            name: "editor_id",
            label: "Editor",
            placeholder: "Select Editor",
            data: [],
            IsRequired: false,
            dependency: "investigator_id" // Indicates this depends on PI selection

          },
          {
            type: "dropdown",
            name: "disease_id",
            label: "Disease",
            placeholder: "Select disease",
            data: [],
            IsRequired: true,
            disabled: false,
          },
          {
            type: "date",
            name: "dob",
            label: "Date of Birth",
            placeholder: "Select Date",
            minDate: false,
            maxDate: oneYearAgo,
            IsRequired: true,
          },
        ],
  });

  const [recordedDateModelData] = useState({
    title: "Add Date",
    children: [
      {
        type: "date",
        name: "last_recorded_visit_date",
        label: "Last Recorded Visit Date",
        placeholder: "Select Date",
        minDate: false,
        maxDate: new Date(),
        IsRequired: true,
      },
    ],
  });

  const handleNavigateToDetails = useCallback((row) => {
    const UpdatedNavigationArray = location.state;
    UpdatedNavigationArray?.push({
      name: "Patient Details",
      path: `${location.pathname}/patient-details/${row[row.length - 6]}`,
    });
    navigate(`patient-details/${row[row.length - 6]}`, {
      state: UpdatedNavigationArray,
    });
  }, []);

  // Function to get Editor for Patient Sub Admin by Value and Phase List ID
  const getEditorForSubjectSubAdmin = async (value) => {
    try {
      return await SubAdminApi.getEditorForSubjectSubAdmin(
        value,
        phaseListDetails?.id
      );
    } catch (error) {
       notify.error(error)
    }
  };

  function arraysEqual(arr1, arr2) {
    // Check if the lengths of both arrays are the same
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Convert all elements to numbers, sort both arrays and compare
    let sortedArr1 = arr1?.map(Number)?.sort((a, b) => a - b); // Convert to number and sort
    let sortedArr2 = arr2?.map(Number)?.sort((a, b) => a - b); // Convert to number and sort

    for (let i = 0; i < sortedArr1?.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;
  }

  const handleShowAddSubjectButton = (data) => {
    let showButton = false;

    if (data?.form_details) {
      // Check if all forms are approved
           showButton = data.form_details.every((value) => value?.is_approved !== false);
    }

    const tempArray = data.form_details.map((form) => {
      return String(form.type.id);
    });

    const IsTempateIdsEqual = arraysEqual(tempArray, data.template_type_ids);
    if (showButton && (role_id == 5 || role_slug === "project-manager")) {
      setSubjectData((prev) => ({
        ...prev,
        TableSearchActions: {
           extraButtons: true,
          ...prev.TableSearchActions,
                    actions: [{ key: "view", module: "subject", auth: 17 }, { key: "add", module: "subject", auth: 16 }, { key: "edit", module: "subject_pending", auth: 161 }],
        },
      }));
    } else {
      setSubjectData((prev) => ({
        ...prev,
        TableSearchActions: {
          ...prev.TableSearchActions,
                   actions: [{ key: "view", module: "subject", auth: 17 }, { key: "add", module: "appointmentManager", auth: 122 },{ key: "edit", module: "subject_pending", auth: 161 }],

        },
      }));
    }

    return showButton && IsTempateIdsEqual;
  };

const getPhaseDetails = async () => {
  setPhaseDetailLoading(true);
  try {
    const res = await PhaseApi.getPhaseListDetails(id);
    setPhaseListDetails(res.data || []);

    const showButtonBoolean = handleShowAddSubjectButton(res?.data);
    setShowAddSubjectButton(showButtonBoolean);

    const principalInvestigators = res.data?.investigator_details?.principal_investigator || [];
    const piDropdownData = principalInvestigators.map(pi => ({
      id: pi.id,
      name: pi.name || `${pi.first_name} ${pi.last_name}`,
      value: pi.id
     }));
    setModelData((prevState) => ({
      ...prevState,
      children: prevState.children.map((child) =>
        child.name === "investigator_id"
          ? {
              ...child, IsRequired: true,
              data: piDropdownData,
            }
 : child.name === "editor_id"
          ? { ...child, IsRequired: false }  // Ensure editor remains required
              : child      ),
      }));

      if (piDropdownData.length > 0 && !isEditor) {
       

        if (!rowId) {
          setEditSubjectPatient(prev => ({
            ...prev,
          }));
        }
      } else if (isEditor) {
        setModelData((prevState) => ({
          ...prevState,
          children: prevState.children.filter(child =>
            child.name !== "investigator_id" && child.name !== "editor_id"
          ),
        }));
      } else {
        setModelData((prevState) => ({
          ...prevState,
          children: prevState.children.map((child) =>
            child.name === "editor_id"
              ? {
                ...child,
                placeholder: "No Principal Investigators available",
                data: [],
                IsRequired: false
              }
              : child
          ),
        }));
      }

      dispatch(setAssignedForm(res?.data?.form_details));
      dispatch(setPhaseDetail(res.data));
    } catch (error) {
      notify.error(error)
    } finally {
      setPhaseDetailLoading(false);
      setLoading(false);
    }
  };

  let isAllApproved = false;
  isAllApproved = phaseListDetails.form_details?.every(
    (item) => item.is_approved
  );

  useEffect(() => {
    setLoading(true);
    const updatedSubjectData = phaseDetailsData(alignment, role_id, role_slug);
    setSubjectData((prev) => ({
      ...prev,
      columnAlign: updatedSubjectData?.columnAlign,
      TableSearchActions: updatedSubjectData?.TableSearchActions,
      columns: updatedSubjectData?.columns,
    }));
    if (alignment === "Request") {
      setSubAdminID(null);
      setStatus([1, 3]);
    } else if (alignment === "Subject") {
      if (isInvestigator || isProjectManager) {
        setStatus(null);
        return;
      }
      setStatusId(null);
      setStatus([2]);
    }
  }, [alignment]);

 const handleOpenAddSubjectModal = async () => {
  setOpenAddSubjectModal(true);
  setRowId(null);
  setDisableDisease(false);
  setEditSubjectPatient(EditSubjectPhase); // This resets everything
  
  setModelData(prevState => ({
    ...prevState,
    children: prevState.children.map(child =>
      child.name === "editor_id"
        ? { 
            ...child, 
            data: [],
            placeholder: "Select PI first to see available editors",
            IsRequired: false 
          }
        : child
    )
  }));
};

  const GetMatchedKey = (key) => {
    switch (key.trim().toLowerCase()) {
      case "patient id": {
        return "patient_id";
      }
      case "patient name": {
        return "name";
      }
      case "patient status": {
        return "life_status";
      }
      case "last recorded visit": {
        return "last_visit_type";
      }
      case "investigator": {
        return "investigator";
      }
      case "phase": {
        return "phase_name";
      }
      case "appointment completed": {
        return "appointmentCount";
      }
      case "editor": {
        return "editor";
      }
      case "cycle no.": {
        return "cycle";
      }
      case "gender": {
        return "gender";
      }
      case "stage": {
        return "stage";
      }
      case "apheresis status": {
        return "apheresis date";
      }
      default:
        return "";
    }
  };
async function getSubjectList() {
  const sortBy = GetMatchedKey(orderBy);

  let investigatorParam = "";
  let editorParam = "";

  const assignedPI = phaseListDetails?.investigator_details?.assigned_investigator?.id;

  if (role_slug === "investigator") {
    investigatorParam = `[${loginId}]`;
     if (subAdminId) {
      editorParam = subAdminId;
    }
  }
  else if (role_slug === "editor") {
    investigatorParam = assignedPI || "";
    editorParam = loginId;
  }
  else {
    investigatorParam = assignedPI || "";

    if (subAdminId) {
      editorParam = subAdminId;  
    } else if (isEditor) {
      editorParam = loginId;
    } else {
      editorParam = "";
    }
  }

  try {
    const res = await SubjectApi.getSubjectList(
      phaseListDetails?.id,
      currentPage,
      10,
      tableFilters?.searchData,
      editorParam,
      role_slug === "project-manager" ? investigatorParam : role_id === 2 ? loginId: "",
      status,
      "",
      sortBy,
      order
    );

    setAllSubjectList(res.data);
    
    const convertedData = convertSubjectData(
      res?.data || [],
      alignment,
      currentPage,
      res?.page_details,
      order,
      phaseListDetails?.isAddNewVisit,
      isAllApproved
    );
    
    // Extract display data for the table
    const rowData = convertedData.map(item => item.displayData);
    
    // Store the full data for cell click handling
    setAllSubjectListData(convertedData);
    
    setSubjectData((prev) => ({
      ...prev,
      rows: [...rowData],
    }));
    
    setTotalPage(
      Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit)
    );
    setCurrentpage(res?.page_details?.page);
    setLoading(false);
  } catch (error) {
    notify.error(error)
    setLoading(false);
    setSubjectData((prev) => ({
      ...prev,
      rows: [],
    }));
  }
}

  useEffect(() => {
    if (phaseListDetails?.id) {
      if (
        tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " "
      ) {
        setLoading(true);
        getSubjectList();
      }
    }
  }, [
    currentPage,
    tableFilters,
    phaseListDetails,
    subAdminId,
    statusId,
    status,
  ]);

  const handlePagination = async (value) => {
    setCurrentpage(value);
  };

  const handleTableFilters = (e) => {
    setTablesFilters({ ...tableFilters, searchData: e });
    setCurrentpage(1);
  };

const handleAddSubject = async (values, confirmation) => {
  SetIsAddSubjectLoading(true);
  setPatientFormValues(values);

  try {
    const formData = new FormData();

    formData.append("first_name", values.first_name?.trim() || "");
    formData.append("last_name", values.last_name?.trim() || "");

    if (values.upload_file) {
      if (values.upload_file instanceof FileList) {
       Array.from(values.upload_file).forEach((file) => {
            formData.append("files", file);
          });
        } else {
          formData.append("files", values.upload_file);
        }
      }

    const genderObj = GenderList.find((op) => op?.id == values.gender);
    formData.append("gender", genderObj?.name || "");
    formData.append("dob", dateofBirthMoment(values.dob));
    formData.append("disease_id", values.disease_id || "");

    formData.append("phase_id", phaseListDetails?.id || "");
    formData.append("phase_code", phaseListDetails?.phase_code || "");
    formData.append("phase_title", phaseListDetails?.title || "");
    formData.append("product_id", phaseListDetails?.product_id || "");
    formData.append("addCycle", confirmation || false);


    let investigatorId = null;
    let editorId = "";
    let projectManagerId = "";

    const principalPI =
  phaseListDetails?.investigator_details?.principal_investigator || [];
    
  const assignedPI = phaseListDetails?.investigator_details?.assigned_investigator;

  if (isEditor) {
    if (assignedPI?.id) {
    investigatorId = assignedPI.id;
    }
    else {
  investigatorId = principalPI?.[0]?.id;

    }

  if (!investigatorId) {
    notify.error("No Principal Investigator assigned to this phase");
    return;
  }

  editorId = loginId;
}

else {
    investigatorId = values?.investigator_id;
  if (!investigatorId || investigatorId === "undefined") {
      notify.error("No Principal Investigator assigned to this phase");
      return;
    }

  if (role_slug === "project-manager") {
    projectManagerId = loginId;
  }

  editorId = values?.editor_id || "";
}
    




    formData.append("investigator_id", String(investigatorId));

    if (editorId && editorId !== "") {
        formData.append("editor_id", String(editorId));
      }

      if (projectManagerId && projectManagerId !== "") {
        formData.append("project_manager", String(projectManagerId));
      }

    

      const response = await SubjectApi.addSubject(formData);

      notify.success(response?.message || "Patient added successfully");

      setLoading(true);
      getPhaseDetails();
      setOpenAddSubjectModal(false);
      setEditSubjectPatient(EditSubjectPhase);

  } catch (error) {

    if (error?.status === 422) {
      const validationErrors = error?.errors || [];

      if (validationErrors.length) {
        const firstError = Object.values(validationErrors[0])[0];
          notify.error(firstError || "Validation failed");
        } else {
          notify.error("Validation failed. Please check all required fields.");
        }
      } else {
        const addCycleError = error?.errors?.find((obj) =>
          Object.prototype.hasOwnProperty.call(obj, "addCycle")
        );

        if (addCycleError) {
          setPatientCycleErrMess(addCycleError?.addCycle);
          setPatientCycleConfirm(true);
        } else {
          notify.error(
            error?.message ||
            (typeof error === "string" ? error : "Failed to add patient")
          );
        }
      }
    } finally {
      SetIsAddSubjectLoading(false);
      if (confirmation) {
        setPatientCycleConfirm(false);
      }
    }
  };

  const hanldeFormSubmit = async (values) => {
    SetIsFormLoading(true); // Reset loading state
    setRecordedDateModel(true);
    setRecordedDate({ ...values, last_recorded_visit_date: "" });
    SetIsFormLoading(false);
    SetIsFormModel(false);
  };

  const getSubjectDropDown = async () => {
  try {
    const data = isInvestigator
      ? { investigator_id: loginId, phase_id: Number(id) }
      : { phase_id: Number(id) };
    const res = await SubAdminApi.getSubAdminDropdown(5, data);
     const filteredEditors = (res?.data || []).filter(
        item => item.role === "editor"
      );
    
    setsubAdminList(filteredEditors);
  } catch (error) {
    notify.error(error)
  }
};

  const getStatusDropDown = async () => {
    try {
      const res = await SubjectApi.subjectStatusDropDown(id);
      setStatusDropdownList(() =>
        res.data.map((item) => {
          return {
            ...item,
            name: `${item.status[0].toUpperCase()}${item.status.slice(1)}`,
          };
        })
      );
    } catch (error) {
       notify.error(error)
    }
  };

  const getDiseaseData = async () => {
    try {
      const decRes = await DiseaseManagementApi.getDiseaseManagementData();
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "disease_id"
            ? { ...child,IsRequired: true, data: decRes?.data }
            : child.name == "gender"
            ? { ...child, data: GenderList }
 : child.name == "editor_id"
          ? { ...child, IsRequired: false } // Ensure editor remains required
          : child        ),
      }));
    } catch (error) {
       notify.error(error)
    }
  };
  useEffect(() => {
    getDiseaseData();
    if ((!isInvestigator && !isProjectManager)) {
      getStatusDropDown();
    } else {
      getSubjectDropDown();
    }
    getPhaseDetails();
  }, []);

  // Function to get Editor Dropdown
// Function to get Editor Dropdown
// In your getEditorDropdown function, add more detailed logging:
const getEditorDropdown = async (Pi_id) => {
  try {
    if (Pi_id && Pi_id !== "undefined") {
      let res = await ProductApi.subadminDropDown(
        5,
        Pi_id,
        phaseListDetails?.id
      );

      // Filter data to show only Editors (role === "editor")
      const filteredEditors = (res?.data || []).filter(
        item => item.role === "editor"
      );
      // Update the editor dropdown data with filtered list
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "editor_id" ? { 
            ...child, 
            data: filteredEditors,
            placeholder: filteredEditors.length > 0 
              ? "Select Editor" 
              : "No editors available for this PI",
            IsRequired: false
          } : child
        ),
      }));

      // ALWAYS reset editor when PI changes for new subjects
      // Only preserve for editing existing subjects
      if (!rowId) {
        setEditSubjectPatient(prev => ({
          ...prev,
          editor_id: "" // Always reset for new subjects
        }));
      }
    } else {
      // When PI is cleared
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "editor_id"
            ? { 
                ...child, 
                placeholder: "Select Principal Investigator first", 
                data: [],
                IsRequired: false
              }
            : child
        ),
      }));
      
      // Clear editor when PI is cleared
      if (!rowId) {
        setEditSubjectPatient(prev => ({
          ...prev,
          editor_id: ""
        }));
      }
    }
  } catch (error) {
    notify.error(error?.message || "Failed to load editors");

    setModelData((prevState) => ({
      ...prevState,
      children: prevState.children.map((child) =>
        child.name === "editor_id"
          ? { 
              ...child, 
              placeholder: "Error loading editors", 
              data: [],
              IsRequired: false
            }
          : child
      ),
    }));
  }
};

  const handleDropDownChange = (e, id) => {
    if (id === "selectSubject") {
      setSubAdminID(e.target.value);
      setCurrentpage(1);
    } else if (id === "selectStatus") {
      if (e.target.value) {
        setStatusId(e.target.value);
        setStatus([e.target.value]);
      } else {
        setStatusId(e.target.value);
        setStatus([1, 3]);
      }
      setCurrentpage(1);
    }
  };

  const findFormTypeID = (form_template_id) =>
    phaseListDetails?.form_details?.find(
      (item) => Number(item.type.id) === Number(form_template_id)
    )?.id;

  const handleAddAppointment = async (row) => {
    try {
      const res = await SubAdminApi?.formTemplateOrderwise({
        subject_id: row[row.length - 6],
        phase_id: row[row.length - 7],
      });
      if (res?.data?.length > 0) {
        const dataUpdated =
          res?.data?.map((item) => ({
            id: item?.form_template_id || findFormTypeID(item?.id),
            title: item?.name,
          })) || [];
        setFormTemplateList(dataUpdated);
        setSubjectId(row[row.length - 6]);
        SetIsFormModel(true);
      } else {
        notify.error("Required numbers of visits have been recorded")
      }
    } catch (error) {
      notify.error(error)
    }
  };

  const handlePatientCycleConfrim = (confirmation) => {
    setPatientFormValues({});
    if (!confirmation) {
      setPatientCycleConfirm(false);
      setOpenAddSubjectModal(false);
      notify.error("Duplicate record not created.")

      return;
    }
    setPatientCycleLoading(true);
    handleAddSubject(patientFormValues, confirmation);
    setPatientCycleLoading(false);
  };

  const handleSelectFormError = (error) => {
    notify.error(error)
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const getGender = async (isGenderName) => {
    return new Promise((resolve) => {
      switch (isGenderName) {
        case "Male":
          setGender(1);
          resolve(1);
          break;
        case "Female":
          setGender(2);
          resolve(2);
          break;
        case "Others":
          setGender(3);
          resolve(3);
          break;
        default:
          resolve(null);
          break;
      }
    });
  };

  const handleEditSubject = async (row) => {

    const rowId = row[row.length - 6];
    setRowId(rowId);
    setDisableDisease(true);

    if (row) {
      setModelData((pre) => ({
        ...pre,
        editTitle: "Edit Patient",
      }));
    }

    const currentPatientData = allSubjectList.find((res) => res.id == rowId);
    const genderValue = await getGender(currentPatientData?.gender);
    getEditorDropdown(currentPatientData?.investigatorDetails?.id, rowId);
    setEditSubjectPatient((prev) => ({
      ...prev,
      first_name: currentPatientData.first_name,
      last_name: currentPatientData?.last_name,
      gender: genderValue,
      dob: currentPatientData?.dob,
      editor_id: currentPatientData?.editorDetails?.id,
      investigator_id: currentPatientData?.investigatorDetails?.id,
      disease_id: currentPatientData?.disease_id,
      phase_id: phaseListDetails?.id,
      phase_code: phaseListDetails?.phase_code,
      phase_title: phaseListDetails?.title,
      addCycle: currentPatientData?.cycle,
    }));
        setOpenAddSubjectModal(true);
  };

  const changeGenderPayload = (value) => {
    let genderTransform = "Male";

    switch (value) {
      case 1:
        genderTransform = "Male";
        break;
      case 2:
        genderTransform = "Female";
        break;
      case 3:
        genderTransform = "Others";
        break;
    }

    return genderTransform;
  };

  const handleEditSubjectSubmit = async (values) => {
    try {
      const payload = { ...values };
      payload.gender = changeGenderPayload(values?.gender);
      const response = await SubjectApi.editPatient(payload, rowId);

      notify.success(response.message || "Patient Edited Successfully")
      await getSubjectList();
      setOpenAddSubjectModal(false);
    } catch (error) {
      notify.error(error.message || error || "Failed to Edit Patient")
    }
  };

  const handleExtra = (row) => {
    const subject = allSubjectList.find((op) => op.id == row[17]);
    if (subject?.feasibility_assessments?.qr_code_generations[0]?.id) {
      navigate(
        `/phases/phase-details/${subject?.phase_id}/patient-details/${subject?.id}/inbound-form/${subject?.feasibility_assessments?.qr_code_generations[0]?.id}`
      );
    }
  };

  useEffect(() => {
    if (orderBy) {
      getSubjectList();
    }
  }, [orderBy, order]);
const getRowIndex = (row) => {
  return subjectData?.rows?.indexOf(row) ?? -1;
};

const handleCellClick = (row, columnIndex) => {
  const rowIndex = getRowIndex(row);
  if (!allSubjectListData || !allSubjectListData[rowIndex]) {
    console.log("No subject data available");
    return;
  }

      const internalData = allSubjectListData[rowIndex]?.internalData;

  
  const editorColumnIndex = alignment === "Subject" ? 9 : -1; // -1 means no editor column in Request view
  
  if (columnIndex === editorColumnIndex) {
    const editorData = internalData?.editorData || [];
    if (editorData.length > 0) {
      setEditorDrawerData(editorData);
      setOpenEditorDrawer(true);
    } else {
      // notify.info("No Editor assigned");
    }
  }
};

// Filter editor list based on search
const filteredEditorDrawerData = editorDrawerData.filter(editor =>
  (editor.name?.toLowerCase() || "").includes(editorSearch.toLowerCase()) ||
  (editor.role?.toLowerCase() || "").includes(editorSearch.toLowerCase())
);
  const handleRecordingDate = async (data) => {
    setRecordedDateLoading(true);
    let updatedValues = {
      title: data.form.title,
      form_template_id: data.form.id || 0,
      phase_id: phaseListDetails.id,
      subject_id: subjectId,
      last_recorded_visit_date: data?.last_recorded_visit_date,
    };

    try {
      const response = await SubjectApi.addAppointment(updatedValues);
      notify.success(response.message || "Appointment added successfully")
      const UpdatedNavigationArray = location.state;
      UpdatedNavigationArray?.push({
        name: "Patient Details",
        path: `${location.pathname}/patient-details/${response?.data?.subject_id}`,
      });
      navigate(`patient-details/${response?.data?.subject_id}`, {
        state: UpdatedNavigationArray,
      });
    } catch (error) {
      notify.error(error?.message || error || "Failed to add appointment")
    } finally {
      setSubjectId("");
      setRecordedDateModel(false);
      setRecordedDateLoading(false);
    }
  };

  useEffect(() => {
    if (rowId) {
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "disease_id" ? { ...child, disabled: true } : child
        ),
      }));
    } else {
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "disease_id" ? { ...child, IsRequired: true, disabled: false } : child
        ),
      }));
    }
  }, [rowId]);

  return (
    <div className="p-6">
      <SelectFormModel
        open={isOpenFormModel}
        setOpen={SetIsFormModel}
        isFormLoading={isFormLoading}
        data={formTemplateList}
        SetIsFormLoading={SetIsFormLoading}
        handleValue={hanldeFormSubmit}
        handleError={handleSelectFormError}
      />

      <CustomModel
        modelData={recordedDateModelData}
        open={recordedDateModel}
        setOpen={setRecordedDateModel}
        modalInitialValues={recordedDate}
        initialValuesValidationSchema={recordedDateSchema}
        handleModelValues={handleRecordingDate}
        resistOverFlow={recordedDateModel ?? false}
        isLoadingBtn={recordedDateLoading}
      />
      {patientCycleConfirm ? (
        <ConfirmationModal
          open={patientCycleConfirm}
          setOpen={setPatientCycleConfirm}
          handleConfirmation={handlePatientCycleConfrim}
          errMessage={patientCycleErrMess}
          isLoading={patientCycleLoading}
        />
      ) : null}
<CustomModel
  rowId={rowId}
  modalInitialValues={rowId ? editSubjectPatient : AddNewSubject}
   initialValuesValidationSchema={
          rowId
            ? editSubjectPhaseValidationSchema
             : isEditor 
          ? addNewSubjectValidationSchema // For editors (no PI/editor fields)
        : addNewSubjectPhaseValidationSchema // For non-editors (with PI/editor fields)
  }
  open={openAddSubjectModal}
  setOpen={setOpenAddSubjectModal}
  modelData={modelData}
  handleModelValues={rowId ? handleEditSubjectSubmit : handleAddSubject}
  isLoadingBtn={isAddSubjectLoading}
  // FIX: Proper onChange handler for PI selection
  onChange={(value, fieldName) => {
    if (fieldName === "investigator_id") {
      getEditorDropdown(value);
    }
  }}
  setRowId={setRowId}
  setDisableDisease={setDisableDisease}
/>
      <div className="mb-3 md:mb-4">
        <BreadCrumb
          BreadCrumbsListing={[
            {
              name: phaseListDetails?.title || 'Phases',
              path: "phases",
            },
            {
              name: "Details",
              path: location.pathname,
            },
          ]}
        />
      </div>
      {phaseListDetails && phaseListDetails.length != 0 ? (
        <div className=" min-h-[25rem] bg-[#FFFFFF]   rounded-xl">
          <CustomWrapperCard
            loading={phaseDetailLoading}
            editDeleteBtn={false}
            disableAddButton={!showAddSubjectButton}
            data={phaseListDetails || {}}
            ShowPI={true}
            ShowEditorCount={isInvestigator}
            ShowProgressBar={false}
            handleAddButtonCard={handleOpenAddSubjectModal}
          />

          <TrialInfoComponent 
          sx={{fontWeight:700}}
            HeaderTitle={"Description"}
            ShowHeaderButton={false}
          >
            {phaseDetailLoading ? (
              <SkeletonLoader
                rowCount={1}
                isTable={false}
                width={500}
                height={20}
              />
            ) : (
              <Typography variant="p" className="break-words">
                {phaseListDetails?.description?.[0]?.toUpperCase() +
                  phaseListDetails?.description?.slice(1) ||
                  "No Description Added"}
              </Typography>
            )}
          </TrialInfoComponent>

           <CustomAccordion
                          accordionClassName="w-100"
                          rootDivClass="pb-3"
                          expanded={expand === "assignedForms"}
                          handleExpansion={() => handleExpand("assignedForms")}
                          noBorderDetail={true}
                          title="Assigned Forms"
                        >
          <TrialInfoComponent

            ShowHeaderButton={false}
          >
            <div className="flex gap-2 justify-start flex-wrap">
              {phaseDetailLoading ? (
                <SkeletonLoader
                  rowCount={2}
                  isTable={false}
                  width={200}
                  height={30}
                />
              ) : (
                <>
                  {phaseListDetails?.form_details?.length > 0
                    ? phaseListDetails?.form_details?.map((item) => (
                        <CustomDetailComponent
                          key={item?.id || ""}
                          BgColor="#2831720D"
                          FirstHeading={item.title  || ""}
                          Icon={<DocumentIcon LightBlue={true} />}
                          ShowDeleteIcon={false}
                        />
                      ))
                    : "No Assigned Forms Found."}
                </>
              )}
            </div>
          </TrialInfoComponent>
          </CustomAccordion>

          {(isInvestigator) &&
            <>
                          <CustomAccordion
                          accordionClassName="w-100"
                          rootDivClass="pb-3"
                          expanded={expand === "assignedEditor"}
                          handleExpansion={() => handleExpand("assignedEditor")}
                          noBorderDetail={true}
                          title="Assigned Editor"
                        >
              <TrialInfoComponent
                ShowHeaderButton={false}
              >
                <div className="flex gap-2 justify-start flex-wrap">
                  {phaseDetailLoading ? (
                    <SkeletonLoader
                      rowCount={2}
                      isTable={false}
                      width={200}
                      height={30}
                    />
                  ) : (
                    <>
                      {phaseListDetails?.editor_details?.length > 0
                        ? phaseListDetails?.editor_details?.map((item) => (
                            <CustomDetailComponent
                              key={item?.id || ""}
                              BgColor="#2831720D"
                              FirstHeading={item?.name || ""}
                              Icon={<InvestigatorIcon />}
                              ShowDeleteIcon={false}
                            />
                          ))
                        : "No Assigned Editor Found."}
                    </>
                  )}
                </div>
              </TrialInfoComponent>
              </CustomAccordion>
            </>
          }

          <div className="p-3">
            <CustomTable
              SearchbarBgColor="secondary"
              alignment={alignment}
              handleExtra={handleExtra}
              setAlignment={setAlignment}
              rows={subjectData?.rows}
              columnAlign={subjectData?.columnAlign}
              columns={subjectData?.columns}
              handleTableFilters={handleTableFilters}
              tableFilters={tableFilters}
              handleChangePage={handlePagination}
              loading={loading}
              currentPage={currentPage}
              totalpage={totalPage}
              TableData={{
                ...subjectData?.TableSearchActions,
                filters: subjectData?.TableSearchActions?.filters?.map(
                  (item) => {
                    if (item?.id === "selectSubject") {
                      return {
                        ...item,
                        MenuList: subAdminList,
                        dropDownValue: subAdminId,
                      };
                    } else if (item?.id === "selectStatus") {
                      return {
                        ...item,
                        MenuList: statusDropdownList,
                        dropDownValue: statusId,
                      };
                    }
                    return item;
                  }
                ),
              }}
              handleAddButton={handleAddAppointment}
              handleEditButton={handleEditSubject}
              handleChangeDropDown={handleDropDownChange}
              handleNavigate={handleNavigateToDetails}
              DropdownBgColor={theme?.palette?.grey[200]}
              order={order}
              orderBy={orderBy}
              EnableSorting={true}
              handleSort={handleSort}
               handleCellClick={(row, columnIndex) => {
    handleCellClick(row, columnIndex);
  }}
            />
          </div>
        </div>
      ) : (
        <div className="mt-4">
          <NoDataCard />
        </div>
      )}
{/* Editor Details Drawer */}
{openEditorDrawer && (
  <CustomDrawer open={openEditorDrawer} toggleDrawer={() => setOpenEditorDrawer(!openEditorDrawer)}>
    <div className="w-[25rem]">
      <div className="pl-4 pt-4 pr-4">
        <HeaderBackNav
          handleBackNav={() => setOpenEditorDrawer(false)}
          TitleFontSize={"18px"}
          TitleFontWeight={700}
          Title="Editor/Patient Navigators Details"
        />
      </div>
      <hr />
      <div className="pl-3 pt-3 pr-3">
        <CustomSearchbar
          Placeholder="Search by Name or Role"
          BgColor="#dfe0eb"
          value={editorSearch}
          handleSearch={(value) => setEditorSearch(value)}
        />
        <ul className="p-2 cursor-pointer">
          {loading ? (
            <SkeletonLoader rowCount={1} height={"35px"} />
          ) : filteredEditorDrawerData?.length === 0 ? (
            <div className="mt-4">
              <Typography variant="body1" className="text-center text-gray-500">
                No details available
              </Typography>
            </div>
          ) : (
            filteredEditorDrawerData?.map((editor, index) => (
              <li
                key={editor?.id || index}
                className="flex gap-3 align-center pt-2 pb-2"
                style={{ borderBottom: "2px solid #dfe0eb" }}
              >
                <div className="self-center">
                        <PersonSvg />
                </div>
                <div className="self-center">
                  <Typography variant="h6">
                    {editor?.name || "Name not available"}
                  </Typography>
                  {editor?.role && (
                    <Typography variant="body2" color="textSecondary">
                      Role: {editor.role}
                    </Typography>
                  )}
                 
                </div>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  </CustomDrawer>
)}
    </div>
  );
};
